// removed by extract-text-webpack-plugin
module.exports = {"Toolbar":"src-components-UI-Spinner-__Spinner-module___Toolbar","Default":"src-components-UI-Spinner-__Spinner-module___Default"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.module.css
// module id = 1163
// module chunks = 1